import(/* webpackMode: "eager" */ "/vercel/path0/src/app/image-upload-and-order-creation/page.tsx");
